import React, { useEffect } from "react";
import CupSelectorColumn from "./CupSelectorColumn";
import ModeSelectorColumn from "./ModeSelectorColumn";
import SettingsPanel from "./SettingsPanel";
import { useTurkishCoffeeCups } from "../../../../../../Hooks/storageRoles/useTurkishCoffeeCups";

export default function BrewingSettingsMatrix({
  initialCups,
  onSave,
  onDiscard,
  saving,
}) {
  const state = useTurkishCoffeeCups(initialCups);

  useEffect(() => {
    state.reset(initialCups);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialCups]);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-end gap-2">
        <button
          type="button"
          onClick={() => {
            state.reset(initialCups);
            onDiscard?.();
          }}
          disabled={!state.dirty}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          ↻ Vazgeç
        </button>
        <button
          type="button"
          onClick={() => onSave(state.cups)}
          disabled={!state.dirty || saving}
          className="px-3 py-1 bg-main text-white rounded disabled:opacity-50"
        >
          {saving ? "Kaydediliyor..." : "✓ Kaydet"}
        </button>
      </div>
      <div className="flex gap-4">
        <CupSelectorColumn
          cups={state.cups}
          selectedCupId={state.selectedCupId}
          onSelect={state.setSelectedCupId}
          onRename={state.renameCup}
          onRemove={state.removeCup}
          onAdd={state.addCup}
          onReorder={state.reorderCups}
        />
        <ModeSelectorColumn
          selectedMode={state.selectedMode}
          onSelect={state.setSelectedMode}
        />
        <SettingsPanel
          cup={state.selectedCup}
          mode={state.selectedMode}
          onCupField={state.setCupField}
          onModeField={state.setModeField}
        />
      </div>
    </div>
  );
}
